import React, { useState } from 'react'

import Button from '@instabox/internal-web-ui/components/Button'
import CheckIcon from '@instabox/internal-web-ui/icons/CheckIcon'
import PlusIcon from '@instabox/internal-web-ui/icons/PlusIcon'

import fetch from '../../fetch'

interface DeleteDeviceButtonProps {
  deviceId: string
  favorite?: boolean
  onDeviceChanged: () => void
}

const DeleteDeviceButton: React.FC<DeleteDeviceButtonProps> = ({ deviceId, favorite, onDeviceChanged }) => {
  const [loading, setLoading] = useState<boolean>(false)

  const handleDeleteDeviceClicked = async () => {
    setLoading(true)

    try {
      await fetch(`/api/device/${deviceId}/favorite`, {
        method: 'PUT',
        body: JSON.stringify({
          favorite: !favorite,
        }),
      })
      onDeviceChanged()
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      data-testid={`favoriteDeviceButton-${deviceId}`}
      shape="outlined"
      variant="success"
      size="sm"
      icon={
        <>
          {favorite && <CheckIcon data-testid="favoriteDeviceButton-checkIcon" />}
          {!favorite && <PlusIcon data-testid="favoriteDeviceButton-plusIcon" />}
        </>
      }
      isLoading={loading}
      onClick={() => handleDeleteDeviceClicked()}
    />
  )
}

export default DeleteDeviceButton
